<template>
  <div class="card shade" @mouseover="toggleCardDarken" @mouseout="toggleCardDarken">
    <router-link :to="'/event/' + event.urlTitle"><span></span></router-link>
    <img class="card-img-top" :src="event.photoUrl">

    <div class="card-body">
      <h5 class="card-title light-weight mb-3">{{ event.title }}</h5>
    </div>

    <div class="card-footer">
      <small class="text-muted date-footer">{{ dateString() }}</small>
    </div>
  </div>
</template>

<script>
import CardMixin from '../mixins/card'
import { Event } from '../data-models/event'

export default {
  mixins: [CardMixin],
  props: {
    event: {
      type: Event,
      required: true
    }
  },
  methods: {
    dateString () {
      const date = this.event.date

      function get (part, opt) {
        let opts = {}
        opts[part] = opt
        return date.toLocaleString('en-us', opts)
      }
      const [
        weekday,
        month,
        day,
        year,
        minute
      ] = [
        get('weekday', 'short'),
        get('month', 'long'),
        get('day', '2-digit'),
        get('year', 'numeric'),
        get('minute', '2-digit')
      ]
      const [hour, amOrPm] = get('hour', '2-digit').split(' ')

      return `${weekday}. ${month} ${day}, ${year} ${hour}:${minute.padStart(2, '0')} ${amOrPm}`
    }
  }
}
</script>

<style>
@import "../assets/styles/card.css";
</style>
